import script from "./UIBannerInstructions.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIBannerInstructions.vue?vue&type=script&lang=ts&setup=true"

import "./UIBannerInstructions.vue?vue&type=style&index=0&id=3f596d0f&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f596d0f"]])

export default __exports__